import React from 'react';
import CustomerForm from '../../components/CustomerForm';

const EditCustomer: React.FC = () => {
  return <CustomerForm />;
};

export default EditCustomer;
